const ADDENDUM = "addendum";
const CLARIFICATION_RESPONSE = "clarificationResponse";
const CONVERSATION_RFX_PRE_SUBMISSION = "conversation_rfx_pre_submission";
const QUOTE_FILE_RESPONSE = "rfq_quote_file_response";

const RETURNABLE_SCHEDULE_FILE_RESPONSE =
	"rfq_returnable_schedule_file_response";
const RETURNABLE_SCHEDULE_FILE_TEMPLATE =
	"rfq_returnable_schedule_file_template";
const RETURNABLE_SCHEDULE_QUESTIONNAIRE_FILE_RESPONSE =
	"rfq_returnable_schedule_questionnaire_file_response";

const RFQ_QUOTE_FILE_TEMPLATE_TYPE = "rfq_quote_file_template";

// PRO-514 RFx documentation uploads. Two contexts route to different
// FileUploadController handlers (see api: app/Http/Controllers/Api/V2/FileUpload/FileUploadController.php):
//   documentation_document               -> creates RfqDocument tied to rfq_id  (real RFx)
//   rfq_document_documentation_file_template -> stores via storeRFxTemplateFile (RFx Template)
const RFQ_DOCUMENTATION_DOCUMENT_TYPE = "documentation_document";
const RFQ_DOCUMENTATION_FILE_TEMPLATE_TYPE = "rfq_document_documentation_file_template";

const FLEXIBLE_QUOTE_FILE_RESPONSE = "flexible_quote_file";

const QUOTE_SUPPORTING_DOCUMENT = "rfq_quote_supporting_document";

// RFx award/not-awarded decision attachments. Uploaded on-the-fly via the
// preferred chunked FileUpload flow → FileUploadController@rfx_award_contract,
// stored as orphans (fileable_id = 0) scoped to the evaluation and stamped with
// the invite id when the decision is sent.
const RFX_AWARD_CONTRACT = "rfx_award_contract";

const PAST_PROJECT_TESTIMONIAL = "past_project_testimonial";

export const FILE_UPLOAD_TYPES = {
	ADDENDUM,
	CLARIFICATION_RESPONSE,
	CONVERSATION_RFX_PRE_SUBMISSION,
	FLEXIBLE_QUOTE_FILE_RESPONSE,
	QUOTE_FILE_RESPONSE,
	QUOTE_SUPPORTING_DOCUMENT,
	RFX_AWARD_CONTRACT,
	RETURNABLE_SCHEDULE_FILE_RESPONSE,
	RETURNABLE_SCHEDULE_FILE_TEMPLATE,
	RETURNABLE_SCHEDULE_QUESTIONNAIRE_FILE_RESPONSE,
	RFQ_QUOTE_FILE_TEMPLATE_TYPE,
	RFQ_DOCUMENTATION_DOCUMENT_TYPE,
	RFQ_DOCUMENTATION_FILE_TEMPLATE_TYPE,
	PAST_PROJECT_TESTIMONIAL,
};
